import { createFileRoute } from "@tanstack/react-router";
import RegexTesterPage from "@/pages/RegexTesterPage";

export const Route = createFileRoute("/tools/regex-tester")({
  component: RegexTesterPage,
});
